import { getIsMobile } from 'src/store/view/selectors';
import { connect } from 'react-redux';
import { frontErrorSelector } from '../../store/selectors/actualization';
import { FlightFail } from './FlightFail';

import { getHotelLinkWithRequestId } from '../../store/selectors/hotel';
import { getPackageId } from '../../store/selectors/package';

export const mapStateToProps = (state) => ({
  frontError: frontErrorSelector(state),
  isMobile: getIsMobile(state),
  hotelUrl: getHotelLinkWithRequestId(state),
  packageId: getPackageId(state),
});

const connector = connect(mapStateToProps);

export default connector(FlightFail);
